export class Country {
    public iso_3166: string;
    public iso_639: string;
    public ny_iso: string;
    public name: string;
    public localized_name: string;
    public currency: string;
    public region: string;
    public app: boolean;
    public loyalty: boolean;
    public latitude: number;
    public longitude: number;


    constructor(data: any) {
        this.iso_3166 = data.iso_3166;
        this.iso_639 = data.iso_639;
        this.ny_iso = data.ny_iso;
        this.name = data.name;
        this.localized_name = data.localized_name;
        this.currency = data.currency;
        this.region = data.region;
        this.app = data.app;
        this.loyalty = data.loyalty;
        this.latitude = data.latitude;
        this.longitude = data.longitude;
    }
}

export type PlaceDetails = {
    id: string;
    placeId: string;
    headline: string;
    address_line_1: string;
    address_line_2: string;
    lat?: number;
    lng?: number;
    isGooglePlace: true;
};

export class Store {
    public id: string;
    public ax_id: string;
    public createdAt: Date;
    public updatedAt: Date;
    public headline: string;
    public city: string;
    public address_line_1: string;
    public address_line_2: string;
    public address_line_3: string;
    public zip: string;
    public phone: string;
    public lat: number;
    public lng: number;
    public openings: StoreOpening[];
    public openingNote: string;
    public marker: google.maps.marker.AdvancedMarkerElement;
    public countryCode: string;
    public stringDistance: string;
    public numberDistance: number;
    public isFavourite: boolean;
    public isOpen: boolean;

    constructor(data: any) {
        this.isOpen = data.isOpen
        this.isFavourite = data.isFavourite || false;
        this.numberDistance = data.numberDistance;
        this.stringDistance = data.distance;
        this.marker = data.marker;
        this.id = data.id;
        this.ax_id = data.ax_id;
        this.createdAt = data.createdAt;
        this.updatedAt = data.updatedAt;
        this.headline = data.address.headline;
        this.city = data.address.city;
        this.countryCode = data.address.country_code;
        this.address_line_1 = data.address.address_line_1;
        this.address_line_2 = data.address.address_line_2;
        this.address_line_3 = data.address.address_line_3;
        this.zip = data.address.zipcode;
        this.phone = data.address.phone;
        this.lat = data.location.latitude;
        this.lng = data.location.longitude;
        this.openings = [];
        if (data.opening_times) {
            for (let op of data.opening_times) {
                this.openings.push(new StoreOpening(op));
            }
        }
        this.openingNote = data.opening_note;
    }
}

export class Map {
    public updatedStores: Store[]
    public closestStores: Store[]
    public positionMarker: google.maps.marker.AdvancedMarkerElement
    public bounds: google.maps.LatLngBounds
    public pos: google.maps.LatLng
    public map: google.maps.Map

    constructor(data: any) {
        this.updatedStores = data.updatedStores
        this.closestStores = data.closestStores
        this.positionMarker = data.positionMarker
        this.bounds = data.bounds
        this.pos = data.pos
        this.map = data.map
    }
}

export enum WeekDay {
    MONDAY = "MONDAY",
    TUESDAY = "TUESDAY",
    WEDNESDAY = "WEDNESDAY",
    THURSDAY = "THURSDAY",
    FRIDAY = "FRIDAY",
    SATURDAY = "SATURDAY",
    SUNDAY = "SUNDAY"
}

export const DAYS_BY_INDEX = [
    WeekDay.SUNDAY,    // 0
    WeekDay.MONDAY,    // 1
    WeekDay.TUESDAY,   // 2
    WeekDay.WEDNESDAY, // 3
    WeekDay.THURSDAY,  // 4
    WeekDay.FRIDAY,    // 5
    WeekDay.SATURDAY   // 6
];

export class StoreOpening {
    public week_day: WeekDay;
    public opening: string;
    public closing: string;
    public open: string;

    constructor(data: any) {
        this.week_day = data.week_day;
        this.opening = data.opening
        this.closing = data.closing
        this.open = data.open
    }
}

export class StoreDelta {
    public items: Store[];
    public deletions: StoreDeletion[];

    constructor(data: any) {
        this.items = data.items ? data.items.map((it: any) => new Store(it)) : [];
        this.deletions = data.deletions ? data.deletions.map((it: any) => new StoreDeletion(it)) : [];
    }
}

export class StoreDeletion {
    public date: Date;
    public store_id: string;

    constructor(data: any) {
        this.date = data.date;
        this.store_id = data.store_id;
    }
}

export interface ICountryService {
    getCountries(): Promise<Country[]>;

    loadCountries(): Promise<Country[]>;

    subscribeForCurrentCountry(tag: string, callback: (country: Country) => void): void;

    setCurrentCountry(country: Country): void;

    getCountryCodeFromLocation(): string;

    getCountryCodeFromUrl(): string;

    routeToCountry(countryCode: string): void;
}


